export const cleanFormData = (data: any): any => {
  if (data.Drugs && Array.isArray(data.Drugs)) {
    data.Drugs = data.Drugs.map((drug: any) => {
      const cleanedDrug: any = {};
      const isCustomDrug = drug.Name && !drug.PackageId;

      Object.entries(drug).forEach(([key, value]) => {
        if (key === "_tempId" || key === "isCustom" || key === "id") return;

        if (isCustomDrug) {
          if (key === "PackageId") return;
          if (key === "Name" && value) {
            cleanedDrug[key] = value;
            return;
          }
        } else if (drug.PackageId && !drug.Name) {
          if (key === "Name") return;
          if (key === "PackageId" && value) {
            cleanedDrug[key] = value;
            return;
          }
        }

        if (
          (key === "Meal" || key === "Frequency") &&
          (value === null || value === undefined)
        ) {
          cleanedDrug[key] = "";
          return;
        }

        if (value !== null && value !== undefined && value !== "") {
          cleanedDrug[key] = value;
        }
      });

      if (isCustomDrug && !cleanedDrug.Name && drug.Name) {
        cleanedDrug.Name = drug.Name;
      }

      return cleanedDrug;
    });
  }

  return data;
};

export const mapTemplateToDrugs = (template: any) => {
  if (!template) return { mappedDrugs: [], formDrugs: [] };

  const mappedDrugs = template.Drugs.map((drug: any, index: number) => {
    const isCustom = !drug.PackageId && !!drug.Name;

    if (isCustom) {
      return {
        Name: drug.Name,
        DrugName: drug.Name || "Custom Drug",
        Image: drug.Image || "",
        FacilityName: drug.Facility || "",
        DosageForm: drug.DosageForm || "",
        _tempId: `template_custom_${index}_${drug.Name}`,
        isCustom: true,
      };
    }

    return {
      PackageId: drug.PackageId,
      DrugName: drug.DrugName,
      Image: drug.Image || "",
      FacilityName: drug.Facility || "Unknown Facility",
      DosageForm: drug.DosageForm || "",
      isCustom: false,
    };
  });

  const formDrugs = template.Drugs.map((drug: any, index: number) => {
    const isCustom = !drug.PackageId && !!drug.Name;

    if (isCustom) {
      return {
        Name: drug.Name, 
        Frequency: drug.FrequencyCode || "",
        SelectedDays:
          drug.Days?.map((day: any) => day.Id).filter(Boolean) || [],
        Meal: drug.MealCode || "",
        Sleep: drug.Sleep || false,
        Times: drug.Times,
        Duration: drug.Duration,
        Instructions: drug.Instructions || "",
        DosageNum: drug.DosageNum,
        DosageUnit: drug.DosageUnit,
        _tempId: `template_custom_${index}_${drug.Name}`,
      };
    }

    return {
      PackageId: drug.PackageId,
      DrugName: drug.DrugName,
      Frequency: drug.FrequencyCode || "",
      SelectedDays: drug.Days?.map((day: any) => day.Id).filter(Boolean) || [],
      Meal: drug.MealCode || "",
      Sleep: drug.Sleep || false,
      Times: drug.Times,
      Duration: drug.Duration,
      Instructions: drug.Instructions || "",
      DosageNum: drug.DosageNum,
      DosageUnit: drug.DosageUnit,
    };
  });

  return { mappedDrugs, formDrugs };
};

// دالة جديدة لدمج الأدوية من القالب مع الأدوية الجديدة
export const mergeDrugs = (existingDrugs: any[], newDrugs: any[]) => {
  if (!existingDrugs || existingDrugs.length === 0) return newDrugs;
  if (!newDrugs || newDrugs.length === 0) return existingDrugs;

  // استخدام Set لتجنب التكرار
  const uniqueDrugs = [...existingDrugs];

  newDrugs.forEach((newDrug) => {
    const exists = existingDrugs.some((existing) => {
      if (newDrug.PackageId && existing.PackageId) {
        return newDrug.PackageId === existing.PackageId;
      }
      if (newDrug.Name && existing.Name) {
        return newDrug.Name === existing.Name;
      }
      return false;
    });

    if (!exists) {
      uniqueDrugs.push(newDrug);
    }
  });

  return uniqueDrugs;
};
